<template>
  <div>
    <div class="border border-opacity-25 rounded-lg shadow-md">
      <form @submit.prevent="postJob">
        <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
          <div class="flex items-center">
            <div class="">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                You're posting a job
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                This information will be used when drivers apply to your jobs.
              </p>
            </div>
          </div>

          <div class="grid grid-cols-6 gap-6">
            <div class="col-span-6">
              <label for="title" class="block text-sm font-medium text-gray-700"
                >Job Title</label
              >
              <input
                v-model="form.title"
                type="text"
                name="title"
                id="title"
                autocomplete="title"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                  disabled:
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.title"
                v-text="form.errors.title"
              ></div>
            </div>

            <div class="col-span-6">
              <div>
                <label
                  for="job-type"
                  class="block text-sm font-medium text-gray-700"
                  >Job Type</label
                >
                <select
                  @change="form.job_type_id = $event.target.value"
                  id="job-type"
                  name="job-type"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option selected disabled class="text-gray-700">
                    please select job type
                  </option>
                  <option
                    v-for="jType in jobType"
                    :selected="form.job_type_id === jType.id"
                    :value="jType.id"
                    :key="jType.id"
                  >
                    {{ jType.name }}
                  </option>
                </select>
                <div
                  class="text-xs text-red-500 mt-1 tracking-wide"
                  v-if="form.errors.job_type_id"
                  v-text="form.errors.job_type_id"
                ></div>
              </div>
            </div>

            <div class="col-span-6 sm:col-span-3">
              <label
                for="description"
                class="block text-sm font-medium text-gray-700"
                >Description</label
              >
              <input
                v-model="form.description"
                type="text"
                name="description"
                id="description"
                autocomplete="email"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                  disabled:bg-gray-100
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.description"
                v-text="form.errors.description"
              ></div>
            </div>

            <div class="col-span-6 md:col-span-3">
              <label for="city" class="block text-sm font-medium text-gray-700"
                >City</label
              >
              <input
                v-model="form.city"
                type="text"
                name="city"
                id="city"
                autocomplete="city"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.city"
                v-text="form.errors.city"
              ></div>
            </div>

            <div class="col-span-6">
              <div>
                <label
                  for="hiring-area-type"
                  class="block text-sm font-medium text-gray-700"
                  >State / Province</label
                >
                <select
                  @change="form.state = $event.target.value"
                  id="hiring-area-type"
                  name="hiring-area-type"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option selected disabled class="text-gray-700">
                    choose an option
                  </option>
                  <option
                    v-for="state in states"
                    :selected="form.state === state"
                    :value="state"
                    :key="state"
                  >
                    {{ state }}
                  </option>
                </select>
                <div
                  class="text-xs text-red-500 mt-1 tracking-wide"
                  v-if="form.errors.state"
                  v-text="form.errors.state"
                ></div>
              </div>
            </div>

            <div class="col-span-6 sm:col-span-3">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
                >Country / Region</label
              >
              <select
                id="country"
                name="country"
                autocomplete="country"
                @change="form.country = $event.target.value"
                class="
                  mt-1
                  block
                  w-full
                  bg-white
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              >
              <option selected disabled class="text-gray-700">
                    choose country / region
                  </option>
                <option selcted :selected="form.country === 'usa'">
                  United States
                </option>
                <option :selected="form.country === 'canada'">Canada</option>
                <option :selected="form.country === 'mexico'">Mexico</option>
              </select>

              <div
                  class="text-xs text-red-500 mt-1 tracking-wide"
                  v-if="form.errors.country"
                  v-text="form.errors.country"
                ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-3">
              <label
                for="zipcode"
                class="block text-sm font-medium text-gray-700"
                >Zipcode</label
              >
              <input
                v-model="form.zipcode"
                type="text"
                name="zipcode"
                id="zipcode"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.zipcode"
                v-text="form.errors.zipcode"
              ></div>
            </div>



            <div class="col-span-6 sm:col-span-3 lg:col-span-4">
              <label
                for="benefits"
                class="block text-sm font-medium text-gray-700"
                >Benefits</label
              >
              <input
                v-model="form.benefits"
                type="text"
                name="benefits"
                id="zip-code"
                autocomplete="zip-code"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.benefits"
                v-text="form.errors.benefits"
              ></div>
            </div>
            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="start-date"
                class="block text-sm font-medium text-gray-700"
                >Start Date</label
              >
              <input
                v-model="form.start_date"
                type="date"
                name="start-date"
                id="start-date"
                autocomplete="start-date"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.start_date"
                v-text="form.errors.start_date"
              ></div>
            </div>
            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="end-date"
                class="block text-sm font-medium text-gray-700"
                >End Date</label
              >
              <input
                v-model="form.end_date"
                type="date"
                name="end-date"
                id="end-date"
                autocomplete="end-date"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.end_date"
                v-text="form.errors.end_date"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="pay-type"
                class="block text-sm font-medium text-gray-700"
                >Pay Type</label
              >
              <input
                v-model="form.pay_type"
                type="text"
                name="pay-type"
                id="pay-type"
                autocomplete="pay-type"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.pay_type"
                v-text="form.errors.pay_type"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="salary-range-from"
                class="block text-sm font-medium text-gray-700"
                >Salary Range From</label
              >
              <input
                v-model="form.salary_range_from"
                type="text"
                name="salary-range-from"
                id="salary-range-from"
                autocomplete="salary-range-from"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.salary_range_from"
                v-text="form.errors.salary_range_from"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="salary-range-to"
                class="block text-sm font-medium text-gray-700"
                >Salaray Range To</label
              >
              <input
                v-model="form.salary_range_to"
                type="text"
                name="salary-range-to"
                id="salary-range-to"
                autocomplete="salary-range-to"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.salary_range_to"
                v-text="form.errors.salary_range_to"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="key-point-1"
                class="block text-sm font-medium text-gray-700"
                >Key Point 1</label
              >
              <input
                v-model="form.key_point_1"
                type="text"
                name="key-point-1"
                id="key-point-1"
                autocomplete="key-point-1"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.key_point_1"
                v-text="form.errors.key_point_1"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="key-point-2"
                class="block text-sm font-medium text-gray-700"
                >Key Point 2</label
              >
              <input
                v-model="form.key_point_2"
                type="text"
                name="key-point-2"
                id="key-point-2"
                autocomplete="key-point-2"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.key_point_2"
                v-text="form.errors.key_point_2"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="key-point-3"
                class="block text-sm font-medium text-gray-700"
                >Key Point 3</label
              >
              <input
                v-model="form.key_point_3"
                type="text"
                name="key-point-3"
                id="key-point-3"
                autocomplete="key-point-3"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.key_point_3"
                v-text="form.errors.key_point_3"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="key-point-4"
                class="block text-sm font-medium text-gray-700"
                >Key Point 4</label
              >
              <input
                v-model="form.key_point_4"
                type="text"
                name="key-point-4"
                id="key-point-4"
                autocomplete="key-point-4"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.key_point_4"
                v-text="form.errors.key_point_4"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="key-point-5"
                class="block text-sm font-medium text-gray-700"
                >Key Point 5</label
              >
              <input
                v-model="form.key_point_5"
                type="text"
                name="key-point-5"
                id="key-point-5"
                autocomplete="key-point-5"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.key_point_5"
                v-text="form.errors.key_point_5"
              ></div>
            </div>

            <div class="col-span-6">
              <div>
                <label
                  for="hiring-area-type"
                  class="block text-sm font-medium text-gray-700"
                  >Hiring Area Type</label
                >
                <select
                  @change="form.hiring_area_type = $event.target.value"
                  id="hiring-area-type"
                  name="hiring-area-type"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option selected disabled class="text-gray-700">
                    choose an option
                  </option>
                  <option
                    v-for="hType in hiringType"
                    :selected="form.hiring_area_type === hType.id"
                    :value="hType.id"
                    :key="hType.id"
                  >
                    {{ hType.name }}
                  </option>
                </select>
                <div
                  class="text-xs text-red-500 mt-1 tracking-wide"
                  v-if="form.errors.hiring_area_type"
                  v-text="form.errors.hiring_area_type"
                ></div>
              </div>
            </div>

            <div v-if="form.hiring_area_type === 'list_of_zip_codes'" class="col-span-6">
              <label
                for="hiring-area-zips"
                class="block text-sm font-medium text-gray-700"
                >List of Zip Codes</label
              >
              <input
                v-model="form.hiring_area_zips"
                type="text"
                name="hiring-area-zips"
                id="hiring-area-zips"
                autocomplete="hiring-area-zips"
                placeholder="list of zipcodes separated by space or comma"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.hiring_area_zips"
                v-text="form.errors.hiring_area_zips"
              ></div>
            </div>

            <div v-if="form.hiring_area_type === 'state'" class="col-span-6">
              <div>
                <label
                  for="hiring-state"
                  class="block text-sm font-medium text-gray-700"
                  >Hiring State</label
                >
                <select
                  @change="form.hiring_area_state = $event.target.value"
                  id="hiring-state"
                  name="hiring-state"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option selected disabled class="text-gray-700">
                    choose an option
                  </option>
                  <option
                    v-for="state in allStates"
                    :selected="form.hiring_area_state === state"
                    :key="`state-${state[0]}`"
                    :value="state[0]"
                  >
                    {{ state[1] }}
                  </option>
                </select>
                <div
                  class="text-xs text-red-500 mt-1 tracking-wide"
                  v-if="form.errors.hiring_area_state"
                  v-text="form.errors.hiring_area_state"
                ></div>
              </div>
            </div>

            <div class="col-span-6 md:col-span-4">
              <div>
                <label
                  for="cdl_class"
                  class="block text-sm font-medium text-gray-700"
                  >CDL Class</label
                >
                <select
                  @change="form.cdl_class = $event.target.value"
                  id="cdl_class"
                  name="cdl_class"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option :selected="!form.cdl_class"></option>
                  <option value="a" :selected="form.cdl_class === 'a'">
                    CDL A
                  </option>
                  <option value="b" :selected="form.cdl_class === 'b'">
                    CDL B
                  </option>
                </select>
              </div>
            </div>

            <div class="col-span-6 lg:col-span-2">
              <div>
                <label
                  for="drug_test"
                  class="block text-sm font-medium text-gray-700"
                  >Drug Test</label
                >
                <select
                  @change="form.drug_test = $event.target.value"
                  id="drug_test"
                  name="drug_test"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option :selected="!form.drug_test"></option>
                  <option value="both" :selected="form.drug_test === 'both'">
                    Must pass both hair and urine drug tests
                  </option>
                  <option value="hair" :selected="form.drug_test === 'hair'">
                    Must pass a hair test
                  </option>
                  <option value="urine" :selected="form.drug_test === 'urine'">
                    Must pass a urine test
                  </option>
                </select>
              </div>
            </div>

            <div class="col-span-6 lg:col-span-3">
              <div>
                <label
                  for="experience_time"
                  class="block text-sm font-medium text-gray-700"
                  >Driving experience</label
                >
                <select
                  @change="form.experience_time = $event.target.value"
                  id="experience_time"
                  name="experience_time"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option selected disabled class="text-gray-700">
                    please select required experience
                  </option>
                  <option value="9" :selected="form.experience_time === 9">
                    Graduated from driving school, Fresh
                  </option>
                  <option value="11" :selected="form.experience_time === 11">
                    3 - 6 months of CDL driving experience
                  </option>
                  <option value="12" :selected="form.experience_time === 12">
                    6 - 12 months of CDL driving experience
                  </option>
                  <option value="13" :selected="form.experience_time === 13">
                    12 - 24 months of CDL driving experience
                  </option>
                  <option value="14" :selected="form.experience_time === 14">
                    24 - 48 months of CDL driving experience
                  </option>
                  <option value="15" :selected="form.experience_time === 15">
                    over 4 years of CDL driving experience
                  </option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-3">
              <div>
                <label
                  for="home_frequency"
                  class="block text-sm font-medium text-gray-700"
                  >Home Frequency</label
                >
                <select
                  @change="form.home_frequency = $event.target.value"
                  id="home_frequency"
                  name="home_frequency"
                  class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none focus:ring-blue-500 focus:border-blue-500
                    sm:text-sm
                    rounded-md
                  "
                >
                  <option disabled :selected="!form.home_frequency">
                    choose an option
                  </option>
                  <option
                    value="daily"
                    :selected="form.home_frequency === 'daily'"
                  >
                    Daily
                  </option>
                  <option
                    value="weekends"
                    :selected="form.home_frequency === 'weekends'"
                  >
                    On Weekends
                  </option>
                  <option
                    value="weekly"
                    :selected="form.home_frequency === 'weekly'"
                  >
                    Every Week
                  </option>
                  <option
                    value="other-week"
                    :selected="form.home_frequency === 'other-week'"
                  >
                    Every other week
                  </option>
                  <option
                    value="three-week"
                    :selected="form.home_frequency === 'three-week'"
                  >
                    Every 3 weeks
                  </option>
                  <option
                    value="month"
                    :selected="form.home_frequency === 'month'"
                  >
                    Every 4 weeks
                  </option>
                </select>
              </div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="reset-hours"
                class="block text-sm font-medium text-gray-700"
                >Reset Hours</label
              >
              <input
                v-model="form.reset_hours"
                type="text"
                name="reset-hours"
                id="reset-hours"
                autocomplete="reset-hours"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.reset_hours"
                v-text="form.errors.reset_hours"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="average-weekly-pay"
                class="block text-sm font-medium text-gray-700"
                >Average Weekly pay</label
              >
              <input
                v-model="form.average_weekly_pay"
                type="text"
                name="average-weekly-pay"
                id="average-weekly-pay"
                autocomplete="average-weekly-pay"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.average_weekly_pay"
                v-text="form.errors.average_weekly_pay"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="average-weekly-miles"
                class="block text-sm font-medium text-gray-700"
                >Average Weekly Miles</label
              >
              <input
                v-model="form.average_weekly_miles"
                type="text"
                name="average-weekly-miles"
                id="average-weekly-miles"
                autocomplete="average-weekly-miles"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.average_weekly_miles"
                v-text="form.errors.average_weekly_miles"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="cost-per-mile"
                class="block text-sm font-medium text-gray-700"
                >Cost per Mile</label
              >
              <input
                v-model="form.cost_per_mile"
                type="text"
                name="cost-per-mile"
                id="cost-per-mile"
                autocomplete="cost-per-mile"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.cost_per_mile"
                v-text="form.errors.cost_per_mile"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="video-url"
                class="block text-sm font-medium text-gray-700"
                >Video URL</label
              >
              <input
                v-model="form.video_url"
                type="text"
                name="video-url"
                id="video-url"
                autocomplete="video-url"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.video_url"
                v-text="form.errors.video_url"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="job-application-url"
                class="block text-sm font-medium text-gray-700"
                >Job Application URL</label
              >
              <input
                v-model="form.job_application_url"
                type="text"
                name="job-application-url"
                id="job-application-url"
                autocomplete="job-application-url"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.job_application_url"
                v-text="form.errors.job_application_url"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label
                for="instant-apply-email"
                class="block text-sm font-medium text-gray-700"
                >Instant Apply Email</label
              >
              <input
                v-model="form.instant_apply_email"
                type="text"
                name="instant-apply-email"
                id="instant-apply-email"
                autocomplete="instant-apply-email"
                class="
                  mt-1
                  block
                  w-full
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  py-2
                  px-3
                  focus:outline-none focus:ring-blue-500 focus:border-blue-500
                  sm:text-sm
                "
              />
              <div
                class="text-xs text-red-500 mt-1 tracking-wide"
                v-if="form.errors.instant_apply_email"
                v-text="form.errors.instant_apply_email"
              ></div>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <SwitchGroup
                as="div"
                class="flex items-center justify-between h-full my-auto"
              >
                <!-- <span class="flex-grow flex flex-col"> -->
                <SwitchLabel
                  as="span"
                  class="text-sm font-medium text-gray-900"
                  passive
                >
                  Touch Freight
                </SwitchLabel>
                <!-- <SwitchDescription as="span" class="text-sm text-gray-500">
                  Touch freight description
                </SwitchDescription> -->
                <!-- </span> -->
                <Switch
                  v-model="form.touch_freight"
                  :class="[
                    form.touch_freight ? 'bg-blue-600' : 'bg-gray-200',
                    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
                  ]"
                >
                  <span
                    aria-hidden="true"
                    :class="[
                      form.touch_freight ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                    ]"
                  />
                </Switch>
              </SwitchGroup>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <SwitchGroup
                as="div"
                class="flex items-center justify-between h-full my-auto"
              >
                <!-- <span class="flex-grow flex flex-col"> -->
                <SwitchLabel
                  as="span"
                  class="text-sm font-medium text-gray-900"
                  passive
                >
                  Twic
                </SwitchLabel>
                <!-- <SwitchDescription as="span" class="text-sm text-gray-500">
                  Twic description
                </SwitchDescription> -->
                <!-- </span> -->
                <Switch
                  v-model="form.twic"
                  :class="[
                    form.twic ? 'bg-blue-600' : 'bg-gray-200',
                    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
                  ]"
                >
                  <span
                    aria-hidden="true"
                    :class="[
                      form.twic ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                    ]"
                  />
                </Switch>
              </SwitchGroup>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <SwitchGroup
                as="div"
                class="flex items-center justify-between h-full my-auto"
              >
                <!-- <span class="flex-grow flex flex-col"> -->
                <SwitchLabel
                  as="span"
                  class="text-sm font-medium text-gray-900"
                  passive
                >
                  Sap
                </SwitchLabel>
                <!-- <SwitchDescription as="span" class="text-sm text-gray-500">
                  Sap description
                </SwitchDescription> -->
                <!-- </span> -->
                <Switch
                  v-model="form.sap"
                  :class="[
                    form.sap ? 'bg-blue-600' : 'bg-gray-200',
                    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
                  ]"
                >
                  <span
                    aria-hidden="true"
                    :class="[
                      form.sap ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                    ]"
                  />
                </Switch>
              </SwitchGroup>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <SwitchGroup
                as="div"
                class="flex items-center justify-between h-full my-auto"
              >
                <!-- <span class="flex-grow flex flex-col"> -->
                <SwitchLabel
                  as="span"
                  class="text-sm font-medium text-gray-900"
                  passive
                >
                  Pet
                </SwitchLabel>
                <!-- <SwitchDescription as="span" class="text-sm text-gray-500">
                  Pet description
                </SwitchDescription> -->
                <!-- </span> -->
                <Switch
                  v-model="form.pets_allowed"
                  :class="[
                    form.pets_allowed ? 'bg-blue-600' : 'bg-gray-200',
                    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
                  ]"
                >
                  <span
                    aria-hidden="true"
                    :class="[
                      form.pets_allowed ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                    ]"
                  />
                </Switch>
              </SwitchGroup>
            </div>

            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <SwitchGroup
                as="div"
                class="flex items-center justify-between h-full my-auto"
              >
                <!-- <span class="flex-grow flex flex-col"> -->
                <SwitchLabel
                  as="span"
                  class="text-sm font-medium text-gray-900"
                  passive
                >
                  Rider
                </SwitchLabel>
                <!-- <SwitchDescription as="span" class="text-sm text-gray-500">
                  Rider description
                </SwitchDescription> -->
                <!-- </span> -->
                <Switch
                  v-model="form.riders_allowed"
                  :class="[
                    form.riders_allowed ? 'bg-blue-600' : 'bg-gray-200',
                    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
                  ]"
                >
                  <span
                    aria-hidden="true"
                    :class="[
                      form.riders_allowed ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                    ]"
                  />
                </Switch>
              </SwitchGroup>
            </div>
          </div>


        </div>
        <div
          class="
            px-4
            py-6
            bg-gray-50
            border-t border-opacity-25
            text-right
            sm:px-6
          "
        >
          <button
            type="submit"
            class="
              bg-blue-600
              border border-transparent
              rounded-md
              shadow-sm
              py-2
              px-4
              inline-flex
              justify-center
              text-sm
              font-medium
              text-white
              tracking-wider
              hover:bg-blue-700
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-blue-500
            "
          >
            Post
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import states from "@/../assets/states.js";

import {
  Switch,
  SwitchDescription,
  SwitchGroup,
  SwitchLabel,
} from "@headlessui/vue";

import { useForm } from "@inertiajs/inertia-vue3";

const route = window.route;

const allStates = Object.entries(states);

const props = defineProps({
  jobType: Object,
});


const { jobType } = props;

const hiringType = [
  {
    id: "list_of_zip_codes",
    name: "List of Zip Codes",
  },
  {
    id: "state",
    name: "State",
  }
];

const form = useForm({
  job_type_id: "",
  title: "",
  description: "",
  internal_description: "",
  city: "",
  state: "",
  zipcode: "",
  country: "",
  benefits: "",
  start_date: "",
  end_date: "",
  pay_type: "",
  salary_range_from: "",
  salary_range_to: "",
  key_point_1: "",
  key_point_2: "",
  key_point_3: "",
  key_point_4: "",
  key_point_5: "",
  hiring_area_type: "",
  hiring_area_zips: "",
  hiring_area_state: "",
  cdl_class: "",
  drug_test: "",
  experience_time: "",
  truck: "",
  home_frequency: "",
  reset_hours: "",
  average_weekly_pay: "",
  average_weekly_miles: "",
  cost_per_mile: "",
  video_url: "",
  job_application_url: "",
  instant_apply_email: "",
  touch_freight: false,
  twic: false,
  sap: false,
  pets_allowed: false,
  riders_allowed: false,
});

const postJob = async () => {
  form.post(route("recruiter.job.post"), {
    onSuccess: () =>form.reset()
  });
};
</script>

<style>
</style>
